import image1 from "./image1.jpeg";
import image2 from "./image2.jpeg";
import image3 from "./image3.jpeg";
import image4 from "./image4.jpeg";
import image5 from "./image5.jpeg";
import image6 from "./image6.jpeg";

import thumbnail1 from "./thumbnail1.jpeg";
import thumbnail2 from "./thumbnail2.jpeg";
import thumbnail3 from "./thumbnail3.jpeg";
import thumbnail4 from "./thumbnail4.jpeg";
import thumbnail5 from "./thumbnail5.jpeg";
import thumbnail6 from "./thumbnail6.jpeg";

export const Images = [
  { image: image1, thumbnail: thumbnail1 },
  { image: image2, thumbnail: thumbnail2 },
  { image: image3, thumbnail: thumbnail3 },
  { image: image4, thumbnail: thumbnail4 },
  { image: image5, thumbnail: thumbnail5 },
  { image: image6, thumbnail: thumbnail6 },
];
